// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__25eOr","label":"LabeledBox_label__LQfa3"};